import { defineComponent } from 'vue';
import Title from '@/components/Title/index.vue';
import Banner from '@/components/Banner2';
import Function from '@/components/Advantages/index.vue';
import Advantages2 from '@/components/Advantages2/index.vue';
import Appointment2 from '@/components/Appointment2/index.vue';
export default defineComponent({
  name: 'vtuber',
  components: {
    Title,
    Banner,
    Function,
    Advantages2,
    Appointment2
  },
  setup() {
    const bannerUrl = require('@/assets/images/FinancialTextReview-banner.png');
    const bannerTitle = '金融文本审核';
    const bannerText = '通过NLP和NLU以及大数据分析等技术，自动化审核工作底稿和文本，智能化检查显示疏漏、错误、谬误。';
    const adsList = [{
      img: require('@/assets/images/ftr-func-1.png'),
      title: '文本纠错',
      desc: '对于文本中的各种错别字、格式错误、语义错误以及不合规等，能够智能识别标记，并提供校正结果。'
    }, {
      img: require('@/assets/images/ftr-func-2.png'),
      title: '数据勾稽',
      desc: '通过上下文数据对比，以及基于金融知识进行逻辑计算，智能识别上下文数据的一致性、准确性，并标记校正。'
    }];
    const adsListLeft = [{
      title: '文本解析能力强',
      desc: 'PDF解析技术成熟，解析准确率达到99%以上。'
    }, {
      title: '文本审核类型多',
      desc: '包括错别字及格式错误、白话、财务指标文表比对、财务数据验算等。'
    }];
    const adsListRight = [{
      title: '错别字识别率高',
      desc: '错别字识别准确率远高于行业平均水平'
    }, {
      title: '服务灵活',
      desc: '提供在线网站和离线工具两种服务形式，灵活响应客户需求'
    }];
    return {
      bannerUrl,
      bannerTitle,
      adsList,
      adsListLeft,
      adsListRight,
      bannerText
    };
  }
});